var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalmarLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.27,
    height: 14.892,
    viewBox: "0 0 13.27 14.892",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M302.48,6.388l-.343-3.9c0-.384.451-.7,1.018-.7s1.018.317,1.018.7l-.343,3.9a.756.756,0,0,1-1.35,0ZM300.35,8.4,296.8,6.744c-.332-.192-.384-.74-.1-1.23s.783-.723,1.116-.531l3.2,2.247a.634.634,0,0,1,.024.79A.641.641,0,0,1,300.35,8.4Zm4.934-1.167,3.2-2.247c.331-.192.831.039,1.116.531s.235,1.039-.1,1.23L305.957,8.4a.646.646,0,0,1-.7-.377A.623.623,0,0,1,305.284,7.229Zm-2.13,4.44a.641.641,0,0,1,.673.415l.343,3.9c0,.386-.451.7-1.018.7s-1.018-.315-1.018-.7l.343-3.9A.642.642,0,0,1,303.154,11.67Zm2.106-1.217a.635.635,0,0,1,.7-.375l3.546,1.649c.343.194.382.742.1,1.234s-.785.721-1.116.53l-3.2-2.238A.65.65,0,0,1,305.26,10.453Zm-4.212,0a.642.642,0,0,1-.024.793l-3.2,2.243c-.332.192-.831-.039-1.116-.53s-.233-1.04.1-1.234l3.546-1.649a.638.638,0,0,1,.7.375Z",
    transform: "translate(-296.52 -1.79)",
    fill: "#041f41"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalmarLogoDark);
export default __webpack_public_path__ + "static/media/walmar-logo-dark.7b38613300c8202b1d5f1f318980dd73.svg";
export { ForwardRef as ReactComponent };